import { createContext } from 'react';

const AssessmentResultContext = createContext({
  accessCode: null,
  answers: {},
  setAccessCode: () => {},
  shouldABTest: false,
  isVariantB: false,
  componentOverrides: {},
});

export default AssessmentResultContext;
